<div class="d-flex align-items-center justify-content-center vh-100">
  <div class="text-center">
    <p data-message [translate]="'userWithoutOrg.message'" class="user-without-org-message"></p>
    <button type="button" mat-flat-button color="primary" (click)="logout()">
      {{ 'userWithoutOrg.button' | translate }}
    </button>
  </div>
</div>
